import React, { useEffect, useState } from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import api from '../../api/api'
import { useTranslation } from 'react-i18next'
import { useProfileStore } from '../../store/useUserStore'

type Props = {}

const Inbox = (props: Props) => {
    const navigate = useNavigate()
    const [notifications, setNotifications] = useState<any>([])
    const { t } = useTranslation()
    const {profile, setLoading} = useProfileStore((state) => state)

    useEffect(() => {
        if (!profile) return // Wait until profile is available
    
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/notification`).then(res => {
            console.log("notification", res.data.data)
            const inboxItem = { id: 0 } // id = 0 set as welcome notification
            setNotifications([...res.data.data, inboxItem])
        }).catch(err => {
            console.log("err cart", err)
        }).finally(()=>{
            setLoading(false)
        })
    }, [profile])

    function formatDate(dateString: string) {
        const date = new Date(dateString)

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kuala_Lumpur',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        })

        const parts = formatter.formatToParts(date)
        const partMap = Object.fromEntries(parts.map(p => [p.type, p.value]))

        const formattedDate = `${partMap.month} ${partMap.day}, ${partMap.year}, ${partMap.hour}:${partMap.minute} ${partMap.dayPeriod}`
        return formattedDate
    }

    function openNotification(notificationId:number) {
        setLoading(true)
        api.post(`${process.env.REACT_APP_API_BASE_URL}/notification/seen/${notificationId}`).then(res => {
            console.log("read", res.data)
        }).catch(err => {
            console.log("err cart", err)
        }).finally(()=>{
            setLoading(false)
            navigate(`/inbox/${notificationId}`)
        })
    }
    

    return (
        <div className="pb-28">
            <div className='mb-2 grid px-3'>
                <div className='text-lg font-medium'>{t("inbox.inbox")}</div>
            </div>

            <div className="pb-2 py-2">
                {notifications.map((notification:any, index:number) => {
                    if (notification.id === 0) {
                        return (
                            <div key={index} className='grid grid-cols-12 gap-2 mx-2  p-2.5 items-center rounded-3xl mb-3 shadow-md' onClick={()=>{openNotification(notification.id)}}>
                                <div className='col-span-2'>
                                    <img src={"/assets/img/koku-logo.png"} alt="" className='w-10 h-10 rounded-3xl'/>
                                </div>
                                <div className='col-span-10 leading-tight'>
                                    <div className='text-md font-semibold m-0 p-0 truncate'>{t('notification_registration.greeting', { name: profile?.name })}</div>
                                    <div className='text-md font-semibold mb-1 p-0 truncate'>{t('notification_registration.welcome')}</div>
                                    <div className='text-md font-light m-0 p-0'>MYKOKU</div>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div key={index} className='grid grid-cols-12 gap-2 mx-2  p-2.5 items-center rounded-3xl mb-3 shadow-md' onClick={()=>{openNotification(notification.id)}}>
                                <div className='col-span-2'>
                                    <img src={notification.sender_pic || "/assets/img/koku-logo.png"} alt="" className='w-10 h-10 rounded-3xl'/>
                                </div>
                                <div className='col-span-6'>
                                    <div className={`text-md truncate ${notification.seen === false ? 'font-semibold' : 'font-light'}`}>{notification.title || "-"}</div>
                                    <div className={`text-md font-light truncate`}>{notification.sender_name || "-"}</div>
                                </div>
                                <div className={`col-span-4 text-xs ${notification.seen === false ? 'font-semibold' : 'font-light'} self-start`}>{notification.sent_at ? formatDate(notification.sent_at) : "-"}</div>
                            </div>
                        )
                    }
                })}
                
            </div>
        </div>
    )
}

export default Inbox